import { IShapeDrawableObject } from "../../../../../../domain/editableFormat/objects";
import { IShapeDrawableObjectBean } from "../../../beans/objects";
import { AbstractObjectTranslator } from "../AbstractObjectTranslator";
import { PrintBehaviorTranslator, LineStyleTranslator } from "../properties";
import { RectangleCoordinatableObjectTranslator } from "./RectangleCoordinatableObjectTranslator";

export class ShapeDrawableObjectTranslator<TObject extends IShapeDrawableObject, TBean extends IShapeDrawableObjectBean> extends AbstractObjectTranslator<TObject, TBean> {
  constructor() {
    super(new RectangleCoordinatableObjectTranslator());
  }

  overwriteObject(source: TObject, bean: TBean, formatId: number): void {
    source.printBehavior = this.printBehavior.from(bean);
    source.lineStyle = this.lineStyle.from(bean);
  }

  overwriteBean(source: TBean, object: TObject): void {
    source["@edit"] = "2";
    source["@hide"] = this.printBehavior.to(object).hide;
    source["@quote"] = "0";
    source["@type"] = this.lineStyle.to(object).type;
    source["@color"] = this.lineStyle.to(object).color;
    source["@border-width"] = this.lineStyle.to(object).borderWidth;
  }

  private readonly printBehavior = new PrintBehaviorTranslator();
  private readonly lineStyle = new LineStyleTranslator();
}
